import React from 'react';
import { UseMutateFunction } from 'react-query';
import { Caption } from 'src/components';
import { HoverCard } from 'src/components/kit';
import { Size, IconSize } from 'src/constants';
import { IUserSignInResponse } from 'src/interfaces';
import UserSearchResult from 'src/interfaces/api/UserSearchResult';
import { palette, Weight } from 'src/theme';
import styled from 'styled-components/native';
import { View } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome5';
import { useAppTheme } from 'src/providers/AppThemeProvider';

interface Props {
  searchResult: UserSearchResult;
  impersonate: UseMutateFunction<IUserSignInResponse, unknown, UserSearchResult, unknown>;
  isFirst: boolean;
  isLast: boolean;
}

const UserSearchResultItem: React.FC<Props> = ({ searchResult, impersonate, isFirst, isLast }) => {
  const { colors } = useAppTheme();

  return (
    <StyledCard isFirst={isFirst} isLast={isLast} onPress={() => impersonate(searchResult)}>
      <ContentContainer>
        <AvatarContainer>
          <Icon name='user' size={Size.S} color={colors.onSurface} />
        </AvatarContainer>
        <UserContainer>
          <Caption>{searchResult.name}</Caption>
          <Caption fontWeight={Weight.MEDIUM}>{searchResult.resourceName}</Caption>
        </UserContainer>
      </ContentContainer>
    </StyledCard>
  );
};

export default UserSearchResultItem;

const StyledCard = styled(HoverCard)<{ isFirst: boolean; isLast: boolean }>`
  border-radius: 0px;
  width: 100%;
  padding-horizontal: ${Size.X2_S}px;
  padding-vertical: ${Size.S}px;
  padding-top: ${({ isFirst }) => (isFirst ? `0px` : `${Size.S}px`)};
  background-color: ${({ theme }) =>
    theme.dark ? palette.BLACK_OPACITY_70 : palette.WHITE_OPACITY_70};
  gap: ${Size.X2_S}px;
  ${({ isLast }) => !isLast && `border-bottom-width: ${Size.X5_S}px;`}
  border-bottom-color: ${({ theme }) => theme.colors.onSurface};
`;

const AvatarContainer = styled.View`
  border-width: ${Size.X5_S}px;
  border-color: ${({ theme }) => theme.colors.onSurface};
  border-radius: ${IconSize.M}px;
  width: ${IconSize.M}px;
  height: ${IconSize.M}px;
  margin-right: ${Size.S}px;
  margin-left: ${Size.X2_S}px;
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled(View)`
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

const UserContainer = styled(View)`
  gap: ${Size.X2_S}px;
`;
